import { type RunHandle, type Runner, type RunRequest, startRun } from "@codeshare/runner-core";

export { RUBY_WASM_VERSION } from "./version";

/** Runs Ruby (CRuby 4.0 on WASI) in a worker. The runtime downloads on first use. */
export const rubyRunner: Runner = {
  id: "ruby",
  name: "Ruby",
  tests: "test_*.rb / *_test.rb files: Minitest::Test or Test::Unit::TestCase classes",
  run(request: RunRequest, options: { timeoutMs?: number } = {}): RunHandle {
    return startRun({
      createWorker: () =>
        new Worker(new URL("./ruby.worker.ts", import.meta.url), { type: "module" }),
      request,
      ...options,
    });
  },
};
